import { FormattedMessage } from "react-intl";
import { IconButton, Tooltip } from "@mui/material";

const ClearButton = ({
  disabled,
  onClear,
}) => {
  return (
    <Tooltip
      arrow
      placement="top"
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -8],
              },
            },
          ],
        },
      }}
      title={<FormattedMessage id="btn.clear" />}
    >
      <IconButton
        disabled={disabled}
        edge="end"
        onClick={onClear}
        sx={{
          fontSize: "inherit",
          marginRight: -1,
        }}
      >
        <i className="nc-icon nc-simple-remove" />
      </IconButton>
    </Tooltip>
  );
};

export default ClearButton;
